export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';

export const SESSION_EXPIRED = 'Sesja utraciła ważność. Zaloguj się ponownie.';

export const LOGOUT_ERROR = 'Wystąpił błąd podczas wylogowywania.';
